import { render, staticRenderFns } from "./HrdcLoader.vue?vue&type=template&id=bd6906e6&scoped=true&"
import script from "./HrdcLoader.vue?vue&type=script&lang=js&"
export * from "./HrdcLoader.vue?vue&type=script&lang=js&"
import style0 from "./HrdcLoader.vue?vue&type=style&index=0&id=bd6906e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6906e6",
  null
  
)

export default component.exports